// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sl-6";
export var imgContainer = "_sl-3";
export var menuIcon = "_sl-5";
export var pillWrapper = "_sl-2";
export var pillsContainer = "_sl-1";
export var subscriptionCard = "_sl-0";
export var subscriptionLogo = "_sl-4";